import * as React from "react";
import PieCharts from "./PieCharts";
import { DiagramData } from "../models/DiagramData";
import { DiagramApiController } from "../models/DiagramApiController.generated";
import GuiReportHeader from "./GuiReportHeader";
import { Diagram } from "./Diagram";
import RevisionTable from "./RevisionTable";
import CalculationTable from "./CalculationTable";
import SvgHftTable from "./Table";
import { GuiReportData } from "../models/GuiReportData";
import { HftBreakdownResults } from "../models/HftBreakdownResults";

interface Props {
  protectiveFunctionId?: number;
  projectId?: number;
}

interface State {
  data?: GuiReportData;
}

class GuiReport extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
    if (this.props.projectId != null || this.props.protectiveFunctionId != null) {
      // Open GUI report for single PF
      DiagramApiController.getReportData(this.props.projectId, this.props.protectiveFunctionId)
        .then(data => this.setState({ data }));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      // this is a little hacky but seems to work.
      // Print after DOM has been rendered and 500 miliseconds past
      setTimeout(() => window.print(), 500);
    }
  }

  renderDiagram(diagramData: DiagramData) {
    return (
      <Diagram
        loading={false}
        deleteConfiguration={null}
        copyBoundDevice={null}
        onPasteBoundDevice={null}
        deleteDevice={null}
        deleteManualInput={null}
        deleteManualAction={null}
        devices={diagramData.devices}
        handleEmptySupportDeviceLocationClick={null}
        handleEmptyDeviceLocationClick={null}
        handleEmptyLogicDeviceLocationClick={null}
        handleUpdateLogicSolverDataClick={null}
        onInputRedundancyChange={null}
        onManualActionSave={null}
        onManualInputsSave={null}
        onUpdateCcf={null}
        onUpdateDeviceSheetData={null}
        manualAction={diagramData.manualAction}
        manualInputs={diagramData.manualInputs}
        psfProtectiveFunctionComments={diagramData.psF_ProtectiveFunctionComments}
        pasteConfiguration={null}
        redundancy={diagramData.protectiveFunction.redundant}
        zoom={1}
        supportConfigPasteState={{ ss1: false, ss2: false }}
        errorsAndWarnings={null}
        setDiagramData={null}
        acceptCalculationResult={() => { }}
        handlePanAndZoomOneUp={() => { }}
        scale={.38}
        readOnly={true}
      />
    );
  }

  render() {
    if (this.state.data == null) {
      return null;
    }
    return (
      <div className="container-fluid">
        {this.state.data.pages.map((page, i) => {
          return (
            <section key={i} className="sheet padding-10mm">
              <img src="/Images/logo.png" style={{position: "absolute", height: "60px", top: 25, right: 50}}/>
              <h3>Protective Function Diagram</h3>
              <GuiReportHeader
                project={this.state.data.project}
                protectiveFunction={page.diagramData.protectiveFunction}
                area={this.state.data.area}
              />
              <div className="row" style={{height: "375px"}}>
                <div className="col-sm-12">
                  {this.renderDiagram(page.diagramData)}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <SvgHftTable hftBreakdownResults={new HftBreakdownResults(page.diagramData.hftResults, page.diagramData.sftTargets && page.diagramData.sftTargets.hftTarget)} />
                </div>
                <div className="col-sm-8">
                  <PieCharts {...page.diagramData} />
                </div>
              </div>
              <div className="row" style={{ marginTop: "10px" }}>
                <div className="col-sm-8">
                  <RevisionTable
                    projectRevision={this.state.data.projectRevision}
                    protectiveRevision={page.protectiveRevision}
                  />
                </div>
                <div className="col-sm-4">
                  <CalculationTable {...page.diagramData} />
                </div>
              </div>
            </section>
          );
      })}
      </div>
    )
  }
}

export default GuiReport;